//
// Module for the Correspondence history view
//
rs.module("framework/content/correspondence/history",

    [
        "common/select-helper",
        "common/visibility"
    ],

    function (selectHelper, visibility) {

        //
        // Initialize the module
        //
        function initialize(jsSelectors, distributionMethods) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            // Send copy card selectors
            var sendCopyCard = criteria.js(jsSelectors.sendCopyCard);
            var sendMethodSelect = sendCopyCard.js(jsSelectors.sendMethodSelect);
            var emailContainer = sendCopyCard.js(jsSelectors.emailContainer);
            var emailControls = sendCopyCard.js(jsSelectors.emailControls, { multiple: true });
            var printContainer = sendCopyCard.js(jsSelectors.printContainer);
            var printerSelect = sendCopyCard.js(jsSelectors.printerSelect);

            // Get select helper(s) for working with select lists
            var printerSelectHelper = selectHelper.getHelper(printerSelect);

            // Handle the send method change event
            sendMethodSelect.change(function () {
                visibility.hide(emailContainer);
                visibility.hide(printContainer);

                var selectedSendMethod = sendMethodSelect.val();
                var isEmail = (selectedSendMethod & distributionMethods.email) == distributionMethods.email;
                var isPrint = (selectedSendMethod & distributionMethods.print) == distributionMethods.print;

                // Enable and disable controls based on the selected send method.
                emailControls.prop('disabled', !isEmail);
                printerSelectHelper.setDisabled(!isPrint);

                visibility.setVisible(emailContainer, isEmail);
                visibility.setVisible(printContainer, isPrint);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);